import React from "react";
import { ClipboardCheck } from "lucide-react";
import SectionDocumentEditor from "./SectionDocumentEditor";
import { BASU_ROUTINE_SECTIONS, BASU_ROUTINE_STATUS_LABELS } from "@/lib/basProcess/basuRoutine";
import { generateBasuRoutineWordDocument } from "@/lib/documentGenerator/basuWordGenerators";

export const BasuRoutine: React.FC<{ projectId: string }> = ({ projectId }) => (
  <SectionDocumentEditor
    projectId={projectId}
    table="basu_routines"
    docNumber="40"
    documentType="basu_rutin"
    title="Rutin – Byggarbetsmiljösamordnare utförande (Bas-U)"
    description="Bas-U:s arbetssätt genom hela produktionen: övertagande, planering, samordning, uppföljning och avslut. Överordnad rutin för Bas-U-dokumenten."
    legalRef="AML 3 kap. 7 b § · AFS 2023:3 kap. 4 · AFS 2023:13 kap. 5"
    icon={ClipboardCheck}
    sections={BASU_ROUTINE_SECTIONS}
    statusLabels={BASU_ROUTINE_STATUS_LABELS}
    defaultName="Rutin Bas-U"
    onExport={(doc, projectName) => generateBasuRoutineWordDocument(doc, projectName)}
    emptyText="Ingen Bas-U-rutin upprättad ännu. Skapa den med förifylld standardtext och anpassa efter projektet."
  />
);

export default BasuRoutine;
